const i = [
  {
    id: "S",
    label: "Small",
    thumbnailRange: { min: 40, max: 48 },
    calloutBoxRange: { min: 208, max: 271 },
    calloutBoxLogoSize: 40,
    fontSizeMultiplier: 0.8,
    tenantLogoSize: 32,
    columns: 1
  },
  {
    id: "M",
    label: "Medium",
    thumbnailRange: { min: 48, max: 59 },
    calloutBoxRange: { min: 272, max: 335 },
    calloutBoxLogoSize: 40,
    fontSizeMultiplier: 1,
    tenantLogoSize: 40,
    columns: 2
  },
  {
    id: "L",
    label: "Large",
    thumbnailRange: { min: 56, max: 63 },
    calloutBoxRange: { min: 336, max: 399 },
    calloutBoxLogoSize: 48,
    fontSizeMultiplier: 1.2,
    tenantLogoSize: 48,
    columns: 2
  },
  {
    id: "XL",
    label: "XLarge",
    thumbnailRange: { min: 64, max: 100 },
    calloutBoxRange: { min: 400, max: 600 },
    calloutBoxLogoSize: 60,
    fontSizeMultiplier: 1.4,
    tenantLogoSize: 56,
    columns: 2
  }
], a = i[1], g = {
  sizeId: a.id,
  rangePosition: 1
}, S = (l, e, t = 0) => {
  const o = i.find((c) => c.id === e) || a, n = l === "Thumbnail" ? o.thumbnailRange : o.calloutBoxRange, u = n.max - n.min, m = n.min + Math.floor(u * t);
  return {
    id: o.id,
    label: o.label,
    range: n,
    size: m,
    calloutBoxLogoSize: o.calloutBoxLogoSize,
    fontSizeMultiplier: o.fontSizeMultiplier,
    tenantLogoSize: o.tenantLogoSize,
    columns: o.columns
  };
}, z = (l, e) => Math.round(l * e);
export {
  g as DEFAULT_CALLOUT_BOX_SIZE,
  a as DEFAULT_SIZE_DEFINITION,
  i as SIZES_DEFINITIONS,
  z as calcFontSize,
  S as getCalloutBoxSizeData
};
//# sourceMappingURL=index.es176.js.map
